import React from 'react';
import { motion } from 'framer-motion';
interface MythSectionProps {
  number: number;
  title: string;
  intro: React.ReactNode;
  truth: React.ReactNode;
  quote: string;
  quoteAuthor: string;
  imageSrc?: string;
  imageAlt?: string;
}
export function MythSection({
  number,
  title,
  intro,
  truth,
  quote,
  quoteAuthor,
  imageSrc,
  imageAlt
}: MythSectionProps) {
  return <motion.section initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} className="max-w-editorial mx-auto px-4 py-10 md:py-16 border-t border-charcoal/10" data-id="element-163">
      <h2 className="text-2xl md:text-3xl font-heading font-semibold text-charcoal mb-6" data-id="element-164">
        <span className="text-accent text-lg block mb-2 font-ui uppercase tracking-widest" data-id="element-165">
          Mythos #{number}
        </span>
        {title}
      </h2>

      <div className="space-y-6 text-lg leading-relaxed text-charcoal/90 mb-8" data-id="element-166">
        {intro}
      </div>

      {imageSrc && <div className="my-10 -mx-4 md:mx-0" data-id="element-167">
          <img src={imageSrc} alt={imageAlt || `Illustration for Myth ${number}`} className="w-full h-auto max-h-[500px] object-cover md:rounded-lg shadow-md" data-id="element-168" />
        </div>}

      <div className="bg-accent-light/30 p-6 md:p-8 rounded-lg mb-8" data-id="element-169">
        <h3 className="text-xl font-heading font-semibold text-charcoal mb-4" data-id="element-170">
          Die Wahrheit:
        </h3>
        <div className="space-y-4 text-lg leading-relaxed text-charcoal/90" data-id="element-171">
          {truth}
        </div>
      </div>

      <blockquote className="pl-6 border-l-4 border-accent italic text-lg text-charcoal/80 my-8" data-id="element-172">
        „{quote}"
        <footer className="mt-2 text-base font-ui not-italic text-charcoal/60" data-id="element-173">
          — {quoteAuthor}
        </footer>
      </blockquote>
    </motion.section>;
}